import { Brand } from '../models/brand';
import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { ApplicationState } from '../../store/application-store';
import { tap, filter, map, distinctUntilChanged } from 'rxjs';
import * as userSettingsSelectors from '../../user-settings/selectors/user-settings'
import { FileHelperService } from '../../common/services/file-helper.service';

@Injectable()
export class BrandProvider { 

  constructor(private readonly store: Store<ApplicationState>) {
  }

  getCurrentBrand(): Observable<Brand> {
    const getCurrentBrand = this.store.select(userSettingsSelectors.getCurrentBrand);
    return getCurrentBrand.pipe(filter((brand) => brand != undefined));
  }

  getCustomerBrandName(): Observable<string> {
    const getCurrentBrand = this.store.select(userSettingsSelectors.getCurrentBrandName);
    return getCurrentBrand.pipe(
      filter((brand) => brand != undefined),
      distinctUntilChanged());
  }

}
